/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */

import React from 'react';

export default class DefaultErrorBoundary extends React.Component {
  constructor() {
    super();
    this.state = { isError: false };
  }

  static getDerivedStateFromError() {
    return { isError: true };
  }

  render() {
    const { isError } = this.state;
    const { children } = this.props;
    return isError ? <div className="page">Something went wrong!</div> : children;
  }
}
